define((require) => {
    "use strict";

    var template = require("ui/experience/widgets/dynamicProductWidget/ProductPropertiesView.tpl"),
        ShowWidgetsView = require("ui/experience/widgets/dynamicProductWidget/ShowWidgetsView"),
        ProductPropertiesModel = require("ui/experience/widgets/dynamicProductWidget/ProductPropertiesModel"),
        CreateAndUpdateDynamicProductWidget = require("ui/experience/widgets/dynamicProductWidget/CreateAndUpdateDynamicProductWidget"),
        Promise = require("shared/util/Promise"),
        AddWidgetsAction = require("ui/actions/AddWidgetsAction"),
        AbstractWidgetPropertiesView = require("ui/experience/widgets/AbstractWidgetPropertiesView"),
        EditorActivities = require("ui/experience/editor/activity/EditorActivities"),
        EditorActivityManager = require("ui/experience/editor/activity/EditorActivityManager"),
        EditorEventFilters = require("ui/editor/EditorEventFilters").default,
        Configuration = require("shared/services/Configuration");

    const EXPAND_PROPERTY = "productExpanded";

    return AbstractWidgetPropertiesView.extend({

        template: template,

        model: null,

        templateHelpers: function() {
            const normalizedInputID = this.model.has("inputProductID") ? this.model.get("inputProductID").toUpperCase()  : null;
            const normalizedProductID = this.model.has("productID") ? this.model.get("productID").toUpperCase()  : null;

            return {
                hasInput: this.model.has("inputProductID"),
                isValidInput: normalizedInputID === normalizedProductID,
                productID: this.model.get("productID"),
                panelName: "Product"
            };
        },

        ui: {
            productIDInput: "#dynamic-product-id-input",
            searchButton: "#search-button"
        },

        regions: {
            actionsRegion: ".toggle-subwidgets-region",
            inputRegion: ".inputRegion"
        },


        events: {
            "keydown @ui.productIDInput": "_enterProductID",
            "click @ui.searchButton": "_pressSearchButton"
        },

        _shouldExpandOnRender() {
            return true;
        },

        onRender() {
            this._$accordionControl = this.$el.find(".collapsible[data-target]");

            if (this._accordionControlsExist()) {
                this._$accordionTarget = this.$el.find(this._$accordionControl.data("target"));
            }
            if (!this._accordionControlsExist()) {
                return;
            }
            this._$accordionTarget.on("show.bs.collapse", () => {
                this._$accordionControl.toggleClass("collapsed", false);
            });

            this._$accordionTarget.on("hide.bs.collapse", () => {
                this._$accordionControl.toggleClass("collapsed", true);
            });

            if (this._shouldExpandOnRender()) {
                this._$accordionTarget.collapse("show");
            }
        },

        onShow: function() {
            this.__super();

            this.actionsRegion.show(new ShowWidgetsView({
                model: this.model,
                groupWidgetView: this.options.widgetView
            }));
        },

        _pressSearchButton() {
            const model = new ProductPropertiesModel();
            const experience = this.viewScope.viewModel.get("experience");

            const self = this;
            self._processInput(experience, model);
        },

        _enterProductID(event) {
            const model = new ProductPropertiesModel();
            const experience = this.viewScope.viewModel.get("experience");

            const self = this;
            if (event.keyCode === 13) {
                self._processInput(experience, model, 0);
            }
        },

        _processInput(experience, propertiesModel, retry) {
            const productID = this.ui.productIDInput[0].value;
            propertiesModel.getProduct(productID, experience.get("language"), experience.get("companyId")).then((product) => {
                this._processAnswerFile(product, experience);
            }).fail((error) => this._processInputWithRetry(error, experience, productID, propertiesModel, retry + 1));
        },

        _processInputWithRetry(error, experience, productID, propertiesModel, retry) {
            let self = this;
            if (!error.responseJSON && retry <= Configuration.maxRetries) {
                setTimeout(() => {
                    self._processInput(experience, propertiesModel, retry);
                }, 500);
            } else {
                this.model.setInputProductID(productID);
                this.render();
            }
        },

        _sleep(time) {
            return new Promise((resolve) => setTimeout(resolve, time));
        },

        _processAnswerFile(product, experience) {
            const productWidget = this.viewScope.viewModel.selection.isSingle() ? this.viewScope.viewModel.selection.get("widgets")[0] : undefined;
            const self = this;
            const scene = self.viewScope.viewModel.get("scene");

            const keys = Object.keys(product.get("products"));
            if (keys.length > 0) {
                // We assume that the answer file either has 0 or 1 product
                const correctProductID = keys[0];
                let currentProduct = product.get("products")[keys[0]];
                if (currentProduct) {
                    if (self.model.has("group") && self.model.get("group").length > 0) {
                        const previousProductWidgetID = self.model.get("productID");
                        const dynamicProductWidgetModel = CreateAndUpdateDynamicProductWidget.updateProductWidget(product, experience, self.model);
                        const currentDynamicProductWidgetID = dynamicProductWidgetModel.get("productID");
                        EditorActivityManager.add(new EditorActivities.DynamicProductWidgetCreatedActivity({
                            dynamicProductWidgetModel: self.model,
                            experience,
                            previousID: previousProductWidgetID,
                            currentID: currentDynamicProductWidgetID,
                            viewScope: self.viewScope
                        }));
                    } else {
                        const previousProductWidget = productWidget.model.clone();
                        CreateAndUpdateDynamicProductWidget.createProductWidget(product, experience, productWidget.model).then((widgetModels) => {
                            new AddWidgetsAction(scene, widgetModels, self.viewScope.viewModel, true, {cause: EditorEventFilters.SUPERFICIAL}).execute().done(() => {
                                const scene = self.viewScope.viewModel.get("activeLayerSceneModel");
                                const newProductWidget = CreateAndUpdateDynamicProductWidget.updateProductWidgetOnScene(scene, self.model, correctProductID, widgetModels);
                                const productID = newProductWidget.get("productID");
                                EditorActivityManager.add(new EditorActivities.DynamicProductWidgetCreatedActivity({
                                    dynamicProductWidgetModel: newProductWidget,
                                    currentID: productID,
                                    previousDynamicProductWidgetModel: previousProductWidget,
                                    experience,
                                    scene,
                                    viewScope: self.viewScope
                                }));
                            });
                        });
                    }
                    if (!experience.get("experienceMetadata").dynamicProductIds.includes(correctProductID)) {
                        experience.get("experienceMetadata").dynamicProductIds.push(correctProductID);
                    }
                }
            }
        }

    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/dynamicProductWidget/ProductPropertiesView.js